import React from "react";
import { Route, Switch } from "react-router-dom";
import asyncComponent from "util/asyncComponent";
import ErrorBoundary from "../routes/System/ErrorBoundary";
import Error from "../routes/System/Error";

// EPI Web UI 路由表：只保留 EPI 申请提交 + 申请列表 + 申请 detail + Admin + 个人资料
const App = ({ match }) => {
  return (
    <div className="gx-main-content-wrapper">
      <ErrorBoundary>
        <Switch>
          <Route path={`${match.url}admin`} component={asyncComponent(() => import('./Admin'))} />
          <Route path={`${match.url}jobs`} component={asyncComponent(() => import('./Business/Job/JobPaging'))} />
          <Route path={`${match.url}my-jobs`} component={asyncComponent(() => import('./Business/Job/MyJobPaging'))} />
          <Route path={`${match.url}job/detail`} component={asyncComponent(() => import('./Business/Job/JobDetail'))} />
          <Route path={`${match.url}epi/lodge`} component={asyncComponent(() => import('./Business/EPI/LodgeApplication'))} />
          <Route path={`${match.url}my-profile`} component={asyncComponent(() => import('./MyProfile'))} />
          <Route path={'/error'} component={Error} />
        </Switch>
      </ErrorBoundary>
    </div>
  )

};

export default App;
